import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { userDashboard, editPorfile } from "../../../Utils/Apis";
import {} from "../../../Utils/Apis";
export const useProfile = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState({ edit: false });

  const {
    post,
    state: { user },
    dispatch,
  } = useMainContext();
  const submit = async () => {
    setLoading({ edit: true });
    const { data, status } = await post(editPorfile, form, true);
    if (+status == 200) {
      dispatch("user", { ...user, user: data });
    }
    setLoading({ edit: false });
  };
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const updateImageProfile = async photo => {
    setLoading({ imageProfile: true });
    const { data, status } = await post(editPorfile, { photo }, true);
    if (+status == 200) {
      dispatch("user", { ...user, user: data });
    }
    setLoading({ imageProfile: false });
  };

  return { loading, user, submit, handler, updateImageProfile };
};
